import { Button } from "./ui/button";
import { Hotel, Factory } from "lucide-react";

const BOOKING_URL = "https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics";

const strategies = [
  {
    icon: Hotel,
    tag: "Hospitality Property",
    parts: [
      "Autonomous Grounds",
      "Indoor Cleaning",
      "Guest Delivery",
      "AI Receptionist",
      "Facility Automation",
    ],
    result: "One Autonomous Property Strategy",
  },
  {
    icon: Factory,
    tag: "Manufacturing Facility",
    parts: [
      "Humanoids",
      "Material Transport",
      "Industrial Cleaning",
      "Inspection",
      "AI Workflows",
    ],
    result: "One Autonomous Facility Strategy",
  },
];

const PropertyAutomationSection = () => (
  <section aria-labelledby="property-automation-heading" className="my-12 md:my-20">
    <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
      <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-primary mb-3">
        Property-wide automation
      </p>
      <h2
        id="property-automation-heading"
        className="font-orbitron font-bold text-[clamp(24px,4vw,40px)] leading-[1.1]"
      >
        We Deploy Transformation, Not Individual Machines
      </h2>
      <p className="mt-4 text-muted-foreground text-base md:text-lg">
        Automation compounds. When indoor, outdoor, industrial, and digital systems run under one
        program, the operational gain is far larger than any single deployment.
      </p>
    </div>

    <div className="grid gap-4 md:grid-cols-2">
      {strategies.map(({ icon: Icon, tag, parts, result }) => (
        <div
          key={tag}
          className="rounded-2xl border border-[hsl(var(--line))] bg-white/[0.03] p-6 md:p-8"
        >
          <div className="flex items-center gap-3 mb-5">
            <Icon className="h-6 w-6 text-primary" aria-hidden="true" />
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
              {tag}
            </span>
          </div>
          <ul className="space-y-2">
            {parts.map((p, i) => (
              <li key={p} className="flex items-center gap-3">
                <span className="text-primary font-bold w-4 shrink-0">{i === 0 ? "" : "+"}</span>
                <span className="text-sm md:text-base font-semibold">{p}</span>
              </li>
            ))}
          </ul>
          <div className="mt-6 pt-5 border-t border-[hsl(var(--line))]">
            <p className="font-orbitron text-base md:text-lg font-bold uppercase tracking-wide text-primary">
              = {result}
            </p>
          </div>
        </div>
      ))}
    </div>

    <div className="mt-8 text-center">
      <Button
        asChild
        size="lg"
        className="rounded-full px-8 font-extrabold min-h-[52px]"
      >
        <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
          Get an Automation Assessment
        </a>
      </Button>
    </div>
  </section>
);

export default PropertyAutomationSection;
